import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export const editDistributor = async (id, unitObject) => {
  const endpoint = `${apiEndpoints.distributors}/${id}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.put(URL, unitObject, { withCredentials: true }))
}
